var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4365 15.5001C13.0777 14.9779 12.7564 14.5142 12.4283 14.0332C14.0518 13.1126 15.4496 11.9755 16.2972 10.2682C16.6835 9.49186 16.9911 8.42694 16.9876 7.89791C16.4613 8.16586 15.9042 8.25861 15.3232 8.238C13.3614 8.17273 11.837 6.89139 11.4918 5.00887C11.0236 2.45993 13.2315 0.168625 15.7743 0.539631C17.5892 0.804144 18.717 1.91373 19.4109 3.51455C20.1935 5.31805 20.1525 7.18338 19.5476 9.02467C18.8093 11.2816 17.3328 12.9855 15.412 14.3115C14.7866 14.7409 14.1133 15.0947 13.4365 15.5001Z",
    fill: "#176089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97196 15.5001C1.6325 15.0077 1.31362 14.5429 0.981012 14.0609C3.42239 12.6974 5.17798 10.8347 5.57573 7.95967C5.21227 8.05264 4.8591 8.19036 4.49563 8.22824C1.99939 8.48991 -0.0305128 6.66162 0.00034727 4.39949C0.0380651 1.67255 2.40058 -0.279699 5.35629 0.804882C6.77585 1.32479 7.60907 2.45069 8.0994 3.80728C8.85719 5.88692 8.67203 7.95623 7.76337 9.95668C6.7347 12.2085 5.02025 13.813 2.90119 15.0146C2.60974 15.1833 2.30114 15.3314 1.97196 15.5001Z",
    fill: "#176089"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quoteIcon.53981948b82fd37d902c041e08a6d0c0.svg";
export { ForwardRef as ReactComponent };